<template>
  <div class="dashboard">
    <div class="dashboard__sidebar sidebar__left">
      <Stats
        :reservations="reservations"
        :unconfirmedReservationsCount="unconfirmedReservationsCount"
      />

      <div class="dashboard__subscription">
        <h3 v-if="userStore.subscription">
          {{ $t("dashboard.subscription_active") }}:
          {{ humanizeDate(userStore.subscription?.end_date) }}
        </h3>
        <h3 v-else class="black">{{ $t("dashboard.subscription_expired") }}</h3>
      </div>
    </div>
    <div class="dashboard__content">
      <div class="dashboard__content__main">
        <h2>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_2845_1733"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2845_1733)">
              <path
                d="M17 15.8173C16.2628 15.8173 15.6362 15.5593 15.1202 15.0433C14.6042 14.5272 14.3461 13.9006 14.3461 13.1635C14.3461 12.4263 14.6042 11.7997 15.1202 11.2837C15.6362 10.7676 16.2628 10.5096 17 10.5096C17.7371 10.5096 18.3637 10.7676 18.8798 11.2837C19.3958 11.7997 19.6538 12.4263 19.6538 13.1635C19.6538 13.9006 19.3958 14.5272 18.8798 15.0433C18.3637 15.5593 17.7371 15.8173 17 15.8173ZM17 14.3173C17.3218 14.3173 17.5945 14.2054 17.8182 13.9817C18.042 13.758 18.1538 13.4853 18.1538 13.1635C18.1538 12.8417 18.042 12.5689 17.8182 12.3452C17.5945 12.1215 17.3218 12.0096 17 12.0096C16.6782 12.0096 16.4054 12.1215 16.1817 12.3452C15.958 12.5689 15.8461 12.8417 15.8461 13.1635C15.8461 13.4853 15.958 13.758 16.1817 13.9817C16.4054 14.2054 16.6782 14.3173 17 14.3173ZM11.3461 22.2691V19.7153C11.3461 19.4258 11.4151 19.1535 11.5531 18.8985C11.6911 18.6434 11.8843 18.4401 12.1327 18.2884C12.6308 17.9913 13.1562 17.7449 13.7089 17.5494C14.2616 17.3539 14.8259 17.2092 15.4019 17.1154L17 19.125L18.5884 17.1154C19.1676 17.2092 19.731 17.3539 20.2789 17.5494C20.8267 17.7449 21.351 17.9913 21.8519 18.2884C22.1006 18.4397 22.2948 18.6423 22.4346 18.8961C22.5743 19.15 22.6474 19.4198 22.6538 19.7057V22.2691H11.3461ZM12.8211 20.7692H16.3866L14.8346 18.7923C14.4814 18.8817 14.1379 18.998 13.8043 19.1411C13.4706 19.2842 13.1429 19.4435 12.8211 19.6192V20.7692ZM17.6134 20.7692H21.1538V19.6192C20.8423 19.4333 20.5197 19.273 20.1861 19.1384C19.8524 19.0038 19.509 18.8916 19.1557 18.8019L17.6134 20.7692ZM5.31227 20.5C4.81051 20.5 4.38302 20.3229 4.02982 19.9689C3.67661 19.6149 3.5 19.1894 3.5 18.6923V5.3077C3.5 4.81058 3.67701 4.38503 4.03102 4.03103C4.38502 3.67701 4.81058 3.5 5.3077 3.5H18.6922C19.1894 3.5 19.6149 3.67701 19.9689 4.03103C20.3229 4.38503 20.5 4.81058 20.5 5.3077V9.6538C20.291 9.41662 20.0682 9.19451 19.8317 8.98748C19.5951 8.78043 19.3179 8.63652 19 8.55575V5.3077C19 5.21795 18.9711 5.14423 18.9134 5.08652C18.8557 5.02882 18.782 4.99998 18.6922 4.99998H5.3077C5.21795 4.99998 5.14423 5.02882 5.08652 5.08652C5.02882 5.14423 4.99997 5.21795 4.99997 5.3077V18.6923C4.99997 18.782 5.02882 18.8557 5.08652 18.9134C5.14423 18.9711 5.21795 19 5.3077 19H9.05382C9.02304 19.1192 8.99996 19.2384 8.98457 19.3577C8.96919 19.4769 8.9615 19.5961 8.9615 19.7153V20.5H5.31227ZM7.25 8.86535H14.4616C14.7987 8.62818 15.1631 8.45191 15.5548 8.33652C15.9465 8.22114 16.3448 8.15704 16.75 8.14423V7.36538H7.25V8.86535ZM7.25 12.75H12.0096C12.0224 12.4833 12.0583 12.2266 12.1173 11.9798C12.1763 11.733 12.2532 11.4897 12.3481 11.25H7.25V12.75ZM7.25 16.6346H10.3731C10.55 16.491 10.7362 16.3592 10.9317 16.2394C11.1272 16.1195 11.3269 16.0128 11.5307 15.9192V15.1346H7.25V16.6346ZM4.99997 19V4.99998V8.54038V8.12498V19Z"
                fill="#1C1B1F"
              />
            </g>
          </svg>
          {{ $t("stats.planned_visits") }}:
        </h2>

        <div
          class="dashboard__content__main__reservations reservations"
          v-if="reservations.length"
        >
          <div
            v-for="reservation in reservations.filter(
              (r) => r.status == ReservationStatus.Confirmed
            )"
            :key="reservation.id"
            class="reservations__item"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_2845_1742"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_2845_1742)">
                <path
                  d="M19 21L12 14L9.65 16.35C9.78333 16.6 9.875 16.8667 9.925 17.15C9.975 17.4333 10 17.7167 10 18C10 19.1 9.60833 20.0417 8.825 20.825C8.04167 21.6083 7.1 22 6 22C4.9 22 3.95833 21.6083 3.175 20.825C2.39167 20.0417 2 19.1 2 18C2 16.9 2.39167 15.9583 3.175 15.175C3.95833 14.3917 4.9 14 6 14C6.28333 14 6.56667 14.025 6.85 14.075C7.13333 14.125 7.4 14.2167 7.65 14.35L10 12L7.65 9.65C7.4 9.78333 7.13333 9.875 6.85 9.925C6.56667 9.975 6.28333 10 6 10C4.9 10 3.95833 9.60833 3.175 8.825C2.39167 8.04167 2 7.1 2 6C2 4.9 2.39167 3.95833 3.175 3.175C3.95833 2.39167 4.9 2 6 2C7.1 2 8.04167 2.39167 8.825 3.175C9.60833 3.95833 10 4.9 10 6C10 6.28333 9.975 6.56667 9.925 6.85C9.875 7.13333 9.78333 7.4 9.65 7.65L22 20V21H19ZM15 11L13 9L19 3H22V4L15 11ZM6 8C6.55 8 7.02083 7.80417 7.4125 7.4125C7.80417 7.02083 8 6.55 8 6C8 5.45 7.80417 4.97917 7.4125 4.5875C7.02083 4.19583 6.55 4 6 4C5.45 4 4.97917 4.19583 4.5875 4.5875C4.19583 4.97917 4 5.45 4 6C4 6.55 4.19583 7.02083 4.5875 7.4125C4.97917 7.80417 5.45 8 6 8ZM12 12.5C12.1333 12.5 12.25 12.45 12.35 12.35C12.45 12.25 12.5 12.1333 12.5 12C12.5 11.8667 12.45 11.75 12.35 11.65C12.25 11.55 12.1333 11.5 12 11.5C11.8667 11.5 11.75 11.55 11.65 11.65C11.55 11.75 11.5 11.8667 11.5 12C11.5 12.1333 11.55 12.25 11.65 12.35C11.75 12.45 11.8667 12.5 12 12.5ZM6 20C6.55 20 7.02083 19.8042 7.4125 19.4125C7.80417 19.0208 8 18.55 8 18C8 17.45 7.80417 16.9792 7.4125 16.5875C7.02083 16.1958 6.55 16 6 16C5.45 16 4.97917 16.1958 4.5875 16.5875C4.19583 16.9792 4 17.45 4 18C4 18.55 4.19583 19.0208 4.5875 19.4125C4.97917 19.8042 5.45 20 6 20Z"
                  fill="#1C1B1F"
                />
              </g>
            </svg>

            <div class="reservations__content">
              <div class="reservations__col">
                <h4>{{ getServiceNames(reservation) }}</h4>
                <div class="reservations__user-info">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <mask
                      id="mask0_3138_44"
                      style="mask-type: alpha"
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="20"
                      height="20"
                    >
                      <rect width="20" height="20" fill="#D9D9D9" />
                    </mask>
                    <g mask="url(#mask0_3138_44)">
                      <path
                        d="M1.7115 16.923C1.35253 16.923 1.04555 16.7956 0.79056 16.5406C0.535574 16.2856 0.408081 15.9786 0.408081 15.6196V4.38038C0.408081 4.02141 0.535574 3.71443 0.79056 3.45944C1.04555 3.20446 1.35253 3.07697 1.7115 3.07697H18.2798C18.6388 3.07697 18.9458 3.20446 19.2008 3.45944C19.4558 3.71443 19.5832 4.02141 19.5832 4.38038V15.6196C19.5832 15.9786 19.4558 16.2856 19.2008 16.5406C18.9458 16.7956 18.6388 16.923 18.2798 16.923H1.7115ZM7.18689 11.7628C7.82257 11.7628 8.36344 11.5398 8.80948 11.0938C9.25553 10.6477 9.47856 10.1069 9.47856 9.47117C9.47856 8.83551 9.25553 8.29465 8.80948 7.84859C8.36344 7.40255 7.82257 7.17953 7.18689 7.17953C6.54766 7.17953 6.00591 7.40255 5.56164 7.84859C5.11738 8.29465 4.89525 8.83551 4.89525 9.47117C4.89525 10.1069 5.11738 10.6477 5.56164 11.0938C6.00591 11.5398 6.54766 11.7628 7.18689 11.7628ZM15.5052 14.8835L16.9807 13.4167L15.8739 11.8804H14.4273C14.3275 11.5513 14.2503 11.2458 14.1954 10.9639C14.1406 10.6821 14.1132 10.3739 14.1132 10.0395C14.1132 9.70513 14.1406 9.39218 14.1954 9.1007C14.2503 8.80921 14.3275 8.4879 14.4273 8.13676H15.8739L16.9807 6.60578L15.5052 5.1389C14.787 5.72688 14.2267 6.45239 13.8244 7.31544C13.4222 8.17851 13.2211 9.08654 13.2211 10.0395C13.2211 10.9868 13.4222 11.884 13.8244 12.731C14.2267 13.5781 14.787 14.2956 15.5052 14.8835ZM2.03416 15.8761H12.3311C11.7235 15.0199 10.9746 14.3381 10.0843 13.8307C9.19401 13.3232 8.2282 13.0695 7.18689 13.0695C6.14773 13.0695 5.17783 13.3232 4.27721 13.8307C3.37657 14.3381 2.62889 15.0199 2.03416 15.8761Z"
                        fill="#535258"
                      />
                    </g>
                  </svg>

                  <div
                    v-for="customer in getCustomersContactInformation(
                      reservation,
                    )"
                    :key="customer.name"
                  >
                    <p>{{ customer.phone }}</p>
                    <p>{{ customer.email }}</p>
                  </div>
                </div>
              </div>

              <div class="reservations__col employee">
                <p>{{ getEmployeesNames(reservation) }}</p>
              </div>

              <div class="reservations__col time">
                <p>{{ humanizeDate(reservation.start_date) }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="reservations no-found" v-else>
          <NoVisits />
        </div>
      </div>
    </div>
    <div class="dashboard__sidebar sidebar__right">
      <UnconfirmedVisits
        @unconfirmed-reservations-count="
          (e) => (unconfirmedReservationsCount = e)
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import Stats from "../components/stats.vue";
import NoVisits from "../components/icons/no-visits.vue";
import UnconfirmedVisits from "../components/unconfirmed-visits.vue";
import { getReservations } from "../services/api.service";
import { useCompanyStore } from "../stores/company.store";
import { Reservation, ReservationStatus } from "../types/reservation.type";
import moment from "moment";
import { humanizeDate } from "../helpers/utils.helper";
import { useUserStore } from "../stores/user.store";

const reservations = ref<Reservation[]>([]);
const companyStore = useCompanyStore();
const userStore = useUserStore();
const unconfirmedReservationsCount = ref<number>(0);

onMounted(async () => {
  const res = await getReservations(
    `${companyStore.currentCompany?.id}`,
    moment().startOf("day").toISOString(),
    moment().endOf("day").toISOString()
  );
  reservations.value = res;
});

const getServiceNames = (reservation: Reservation) => {
  return reservation.services.map((service) => service.name).join(", ");
};

const getEmployeesNames = (reservation: Reservation) => {
  return reservation.employees.map((employee) => employee.name).join(", ");
};

const getCustomersContactInformation = (reservation: Reservation) => {
  return reservation.customers.map((customer) => {
    return {
      name: customer.name,
      phone: customer.phone_number,
      email: customer.email,
    };
  });
};

const getDaysLeft = (end_date: string | undefined) => {
  if (!end_date) return 0;
  const end = moment(end_date);
  const now = moment();
  return end.diff(now, "days");
};
</script>

<style lang="scss" scoped>
.dashboard {
  display: flex;
  gap: 14px;
  flex-direction: column-reverse;
  padding: 0 10px;

  @media screen and (min-width: 1200px) {
    justify-content: space-between;
  }

  @media screen and (min-width: 768px) {
    flex-wrap: wrap;
    flex-direction: row;
  }

  &__sidebar {
    position: relative;
    border-radius: 20px;
    height: calc(95vh - 126px);
    background-color: #fff;
    width: 100%;
  }

  .sidebar__left {
    flex: 1;
    padding-bottom: 40px;
    padding-top: 14px;
  }

  .dashboard__content {
    flex: 2;
    background-color: #fff;
    border-radius: 20px;
    height: calc(95vh - 126px);

    h2 {
      font-family: "Poppins", sans-serif;
      font-weight: 600;
      font-size: 18px;
      line-height: 200%;
      color: #1f2937;
      margin-bottom: 20px;
    }

    .dashboard__content__main {
      padding: 24px 20px;
      height: 100%;
    }
  }

  .sidebar__right {
    flex: 1;
  }

  &__subscription {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;

    h3 {
      font-weight: 500;
      font-size: 12px;
      letter-spacing: -0.01em;
      color: rgba(0, 0, 0, 0.7);
      margin-bottom: 0;
    }
  }
}

.reservations {
  height: 100%;
  overflow: scroll;

  &.no-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 56px);
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 18px;
    color: #1f2937;
  }

  &__content {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  &__col {
    display: flex;
    flex-direction: column;
    gap: 10px;

    &.employee,
    &.time {
      align-items: center;
      flex-direction: row;
      border-radius: 10px;
      padding: 12px 24px;
      background: #403838;
      align-items: center;

      p {
        font-family: "Montserrat", sans-serif;
        font-weight: 500;
        font-size: 12px;
        line-height: 100%;
        text-align: center;
        color: #fff;
        margin: 0;
      }
    }
  }

  &__item {
    border: 1px solid #eff0f6;
    border-radius: 18px;
    background: #e7eaee;
    padding: 14px;
    font-family: "Inter", sans-serif;
    margin-bottom: 10px;
    display: flex;
    gap: 10px;
    align-items: center;

    p {
      font-weight: 700;
      font-size: 24px;
      color: #000;
    }

    h4 {
      font-family: "Montserrat", sans-serif;
      font-weight: 600;
      font-size: 14px;
      line-height: 100%;
      color: #403838;
    }
  }

  &__user-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    p {
      font-family: "Montserrat", sans-serif;
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 0;
      color: #000;
    }
  }
}
</style>
